import {memo} from 'react';

import {UserMenu} from '#features/user_menu/index.js';
import {
  hasPermission,
  NAVIGATION_POLICY_REQUEST,
  usePolicyCheck,
} from '#queries/policies/index.js';
import {useSessionStore} from '#stores/session/index.js';

import {WhatsNew} from '../announcekit/index.js';
import * as styles from './style.css.js';

export const Toolbar = memo(function Toolbar() {
  const {user} = useSessionStore();
  const {data: policyData} = usePolicyCheck(NAVIGATION_POLICY_REQUEST);
  const displayName = user?.nickname || user?.name || 'User';
  const showAdminLinks = hasPermission(policyData, 'application', 'app_admin');
  const showOrganizationLink = hasPermission(
    policyData,
    'organization',
    'show'
  );

  return (
    <header className={styles.container}>
      <div className={styles.spacer} />
      <div className={styles.actions}>
        <a
          href="https://docs.growthloop.com/docs/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Documentation
        </a>
        <WhatsNew />
        <UserMenu
          name={displayName}
          profileURL="/user"
          organizationURL={showOrganizationLink ? '/organization' : undefined}
          adminURL={showAdminLinks ? '/admin/organizations' : undefined}
          globalAppsURL={showAdminLinks ? '/admin/global_apps' : undefined}
          debugURL={showAdminLinks ? '/admin/debug' : undefined}
        />
      </div>
    </header>
  );
});
